<div class="modal-header">
    <span class="modal-title">Capture Image</span>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <app-camera (pictureTaken)="handleImage($event)" (webcamError)="handleInitError($event)" class="camera">
    </app-camera>
    <div style="text-align:center" *ngIf="webcamImage">
        <img [src]="webcamImage.imageAsDataUrl" class="snapshot" />
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">Close</button>
    <button type="button" ngbAutofocus class="btn btn-danger"
        (click)="submit()">{{errors?.length === 0 ? 'Confirm' : 'Continue Anyway'}}</button>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>